<script>
import baseMixin from '@/mixins/baseMixin'
import BookingListSkeleton from './booking-list-skeleton.vue'

export default {
  name: 'BookingListGroupSkeleton',
  components: { BookingListSkeleton },
  mixins: [baseMixin],
  props: {
    groups: {
      type: Number,
      default: 1,
    },
    rows: {
      type: Number,
      default: 3,
    },
  },
}
</script>

<template>
  <section>
    <div v-for="(group, index) in groups" :key="index">
      <v-skeleton-loader
        class="mb-6 ml-2"
        type="heading"
        width="500px"
      ></v-skeleton-loader>

      <BookingListSkeleton :rows="rows" />
    </div>
  </section>
</template>
